/*
 * @Author: showVinc
 * @Date: 2019-01-26 12:54:36
 * @Description: file content
 */
import Vue from 'vue'
import Vuex from 'vuex'

import axios from '@/plugins/axios'
import router from '@/router'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        userInfo: null,
        token: sessionStorage.getItem('__wallet__') || null
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload;
        },
        REMOVE_TOKEN(state, payload) {
            state.token = null;
            state.userInfo = null;
        },
        SET_USERINFO(state, payload) {
            state.userInfo = { ...payload };
        },
        LOGOUT(state, payload) {
            state.userInfo = null;
            sessionStorage.removeItem('__wallet__');
            axios.defaults.headers.common['Authorization'] = null;
            router.push({ path: '/' })
                .catch(err => {
                    console.log("router err");
                });
        }
    },
    actions: {
        async networkChange() {
            let res = await window.CHAIN.WALLET.networkChangedAssign;
            console.log(res)
        },
        async accountsChange({ }, params) {
            let res = await window.CHAIN.WALLET.accountsChangedAssign(params);
            console.log(res)
        },
        changeWorks({
            dispatch,
            commit
        }, params) {
            router.push({ path: '/series/works', query: { worksId: params } })
                .catch(err => {
                    console.log("router err");
                });
        },
        changeAuthor({
            dispatch,
            commit
        }, params) {
            router.push({ path: '/series/author', query: { authorId: params } })
                .catch(err => {
                    console.log("router err");
                });
        },
        changeSeries({
            dispatch,
            commit
        }, params) {
            router.push({ path: '/series', query: { seriesId: params } })
                .catch(err => {
                    console.log("router err");
                });
        },
        changeRouter({
            dispatch,
            commit
        }, params) {
            router.push(params)
                .catch(err => {
                    console.log("router err");
                });
        },
        async getUserInfo({
            dispatch,
            commit
        }, params) {
            let res = await axios.get('/users');
            if (!res.errno) {
                commit('SET_USERINFO', res.data);
            }
        }
    },
    getters: {
        isDev() {
            return Boolean(process.env.NODE_ENV === 'development')
        },
        isLogin(state) {
            return Boolean(state.userInfo)
        },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js